import { ReactNode } from 'react';
import { Text } from "@chakra-ui/layout";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Outlet, Link as RLink } from "react-router-dom";
import { useAppSelector } from "../../store/hook";
import { defaultState, setUser } from "../../store/state/authSlice";
import {
  Box,
  Flex,
  Avatar,
  HStack,
  Link,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  useToast,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { useSignOutUserMutation } from '../../store/api';

const Links = ['Menu Item 1', 'Menu Item 2', 'Menu Item 3'];

const NavLink = ({ children }: { children: ReactNode }) => (
  <Link
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.200', 'gray.700'),
    }}
    href={'#'}>
    {children}
  </Link>
);

const Home = () => {
  let { user } = useAppSelector((state) => state.auth);
  const { isOpen, onOpen, onClose } = useDisclosure();
  if (!user) {
    user = JSON.parse(localStorage.getItem("user") || '');
  }
  const navigate = useNavigate();
  const toast = useToast();
  const dispatch = useDispatch();
  const [signOutUser, { data, isLoading, error, isError, isSuccess }] = useSignOutUserMutation();
  const signout = () => {
    signOutUser('').unwrap().then(() => {
      localStorage.clear();
      dispatch(setUser({ token: '', user: null, refreshToken: '' }));
      toast({
        title: "successfully logged out",
        status: "success",
        duration: 3000,
      });
      navigate("/signin");
    }).catch((error) => {
      console.log(error);
      toast({
        title: error?.data?.message || "Logout Error",
        status: "error",
        duration: 3000,
      });
    });
  };

  return (
    <>
      <Box bg={useColorModeValue('gray.100', 'gray.900')} px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <Box>
              <Text as={RLink} to="/" color="teal">
                Price Watch
              </Text>
            </Box>
            <HStack
              as={'nav'}
              spacing={4}
              display={{ base: 'none', md: 'flex' }}>
              {Links.map((link) => (
                <NavLink key={link} >{link}</NavLink>
              ))}
            </HStack>
          </HStack>
          <Flex alignItems={'center'}>
            <Menu>
              <MenuButton
                as={Button}
                variant={'text'}
                cursor={'pointer'}
                minW={0}>
                <Text color="teal">
                  {user?.firstName} {user?.lastName}
                </Text>
              </MenuButton>
              <MenuList>
                <MenuItem>
                  <Text as={RLink} to="/change-password" fontSize="small" color="teal">
                    Change Password
                  </Text>
                </MenuItem>
                <MenuItem>
                  <Text as={RLink} onClick={signout} to="/" fontSize="small" color="teal">
                    Sign out
                  </Text>
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
              {Links.map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>

      {/* <Box p={4}>Main Content Here</Box> */}
      <Outlet />
    </>
  );
};

export default Home;
